webpackJsonp([24],{

/***/ 209:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var uuid = localStorage.uuid || 0;
var rolID = localStorage.rolID || 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  url: 'https://gestionibec.com/api/1.0/',
  // url: 'http://localhost:8088/app/api/1.0/',
  sufix: '?user_id=' + uuid + '&rol_id=' + rolID,
  token_renewal_route: 'user/renew-authorization/',
  roles: ['superadmin', 'administrator', 'supervisor', 'commerce', 'installer', 'guest', 'manager', 'responsible']
});

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app__ = __webpack_require__(280);




var _createApp = Object(__WEBPACK_IMPORTED_MODULE_2__app__["a" /* createApp */])(),
    app = _createApp.app,
    router = _createApp.router,
    store = _createApp.store;

router.onReady(function () {
  router.beforeResolve(function (to, from, next) {
    var matched = router.getMatchedComponents(to);
    var prevMatched = router.getMatchedComponents(from);
    var diffed = false;
    var activated = matched.filter(function (c, i) {
      return diffed || (diffed = prevMatched[i] !== c);
    });
    if (!activated.length) {
      return next();
    }
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(activated.map(function (c) {
      if (c.asyncData) {
        return c.asyncData({ store: store, route: to });
      }
    })).then(function () {
      next();
    }).catch(next);
  });

  app.$mount('#app');
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createApp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config_theme__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_router_index__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_index__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_Vuetify__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_Vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_Vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VApp__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCard__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VForm__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VTextField__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VTextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VCheckbox__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VCheckbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VCheckbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VNavigationDrawer__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VNavigationDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VNavigationDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VFooter__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VBadge__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VBadge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VBadge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VList__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VBtn__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VSwitch__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VIcon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VGrid__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VToolbar__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSnackbar__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSnackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSnackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VExpansionPanel__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VDialog__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VDivider__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VDivider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VDivider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VDataTable__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VTooltip__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VAvatar__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VAvatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VAvatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VBtnToggle__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VBtnToggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VBtnToggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_transitions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_transitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_transitions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VRadioGroup__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VRadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VRadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VCarousel__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VCarousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VCarousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VSlider__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VSlider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VSlider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VMenu__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTabs__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VSpeedDial__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VSpeedDial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VSpeedDial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSelect__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VChip__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VChip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VChip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VStepper__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VStepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VAlert__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VAlert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vuetify_es5_components_VDatePicker__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vuetify_es5_components_VDatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_vuetify_es5_components_VDatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_vuetify_es5_components_VTimePicker__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_vuetify_es5_components_VTimePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_vuetify_es5_components_VTimePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_vuetify_es5_components_VProgressCircular__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_vuetify_es5_components_VProgressCircular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_vuetify_es5_components_VProgressCircular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_vuetify_es5_components_VBottomSheet__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_vuetify_es5_components_VBottomSheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_vuetify_es5_components_VBottomSheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__node_modules_vuetify_src_stylus_app_styl__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__node_modules_vuetify_src_stylus_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__node_modules_vuetify_src_stylus_app_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_vue_awesome_notifications__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_vue_awesome_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_vue_awesome_notifications__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_Vuetify___default.a, {
  components: {
    VApp: __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VApp___default.a,
    VCard: __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VCard___default.a,
    VForm: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VForm___default.a,
    VTextField: __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VTextField___default.a,
    VCheckbox: __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VCheckbox___default.a,
    VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VNavigationDrawer___default.a,
    VFooter: __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VFooter___default.a,
    VBadge: __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VBadge___default.a,
    VList: __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VList___default.a,
    VBtn: __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VBtn___default.a,
    VSwitch: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VSwitch___default.a,
    VIcon: __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VIcon___default.a,
    VGrid: __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VGrid___default.a,
    VToolbar: __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VToolbar___default.a,
    VSnackbar: __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VSnackbar___default.a,
    VExpansionPanel: __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VExpansionPanel___default.a,
    VDialog: __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VDialog___default.a,
    VSubheader: __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VSubheader___default.a,
    VDivider: __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VDivider___default.a,
    VDataTable: __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VDataTable___default.a,
    VTooltip: __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VTooltip___default.a,
    VAvatar: __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VAvatar___default.a,
    VBtnToggle: __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VBtnToggle___default.a,
    transitions: __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_transitions___default.a,
    VRadioGroup: __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VRadioGroup___default.a,
    VCarousel: __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VCarousel___default.a,
    VSlider: __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VSlider___default.a,
    VMenu: __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VMenu___default.a,
    VTabs: __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VTabs___default.a,
    VSpeedDial: __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VSpeedDial___default.a,
    VSelect: __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VSelect___default.a,
    VChip: __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VChip___default.a,
    VStepper: __WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VStepper___default.a,
    VAlert: __WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VAlert___default.a,
    VDatePicker: __WEBPACK_IMPORTED_MODULE_41_vuetify_es5_components_VDatePicker___default.a,
    VTimePicker: __WEBPACK_IMPORTED_MODULE_42_vuetify_es5_components_VTimePicker___default.a,
    VProgressCircular: __WEBPACK_IMPORTED_MODULE_43_vuetify_es5_components_VProgressCircular___default.a,
    VBottomSheet: __WEBPACK_IMPORTED_MODULE_44_vuetify_es5_components_VBottomSheet___default.a
  }
});


var options = {
  position: 'top-right',
  duration: 4000,
  labels: {
    info: 'Info',
    success: 'Éxito',
    tip: 'Tip',
    warning: 'Atención',
    alert: 'Error'
  }
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_46_vue_awesome_notifications___default.a, options);
__webpack_require__(493);

function createApp() {
  var store = Object(__WEBPACK_IMPORTED_MODULE_4_store_index__["a" /* createStore */])();
  var router = Object(__WEBPACK_IMPORTED_MODULE_3_router_index__["a" /* createRouter */])(store);

  Object(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__["sync"])(store, router);

  // store.dispatch('api/initApp')

  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

  /* eslint-disable no-new */
  var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: router,
    store: store,
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
    template: '<App/>'
  });

  return { app: app, router: router, store: store };
}

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_493f7638_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(290);
function injectStyle (ssrContext) {
  __webpack_require__(284)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_493f7638_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 284:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var meta = __webpack_require__(79);

/* harmony default export */ __webpack_exports__["a"] = ({
  watch: {
    '$route': function $route() {
      this.setMeta();
    }
  },

  mounted: function mounted() {
    this.setMeta();
  },


  methods: {
    setMeta: function setMeta() {
      if (typeof document === 'undefined') return;

      var metaData = meta[this.$route.name] || {};

      document.title = metaData.title;
      document.querySelector('meta[name="description"]').setAttribute('content', metaData.description);
      document.querySelector('meta[name="keywords"]').setAttribute('content', metaData.keywords);
    }
  }
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config_theme__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  watch: {
    '$route': function $route() {
      this.setColors();
    }
  },

  created: function created() {
    this.setColors();
  },


  methods: {
    setColors: function setColors() {
      if (this.$route.name && __WEBPACK_IMPORTED_MODULE_0_config_theme__["a" /* default */].route[this.$route.name]) {
        this.$vuetify.theme = __WEBPACK_IMPORTED_MODULE_0_config_theme__["a" /* default */].route[this.$route.name].colors;
      }
    }
  }
});

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 80,
	"./af.js": 80,
	"./ar": 81,
	"./ar-dz": 82,
	"./ar-dz.js": 82,
	"./ar-kw": 83,
	"./ar-kw.js": 83,
	"./ar-ly": 84,
	"./ar-ly.js": 84,
	"./ar-ma": 85,
	"./ar-ma.js": 85,
	"./ar-sa": 86,
	"./ar-sa.js": 86,
	"./ar-tn": 87,
	"./ar-tn.js": 87,
	"./ar.js": 81,
	"./az": 88,
	"./az.js": 88,
	"./be": 89,
	"./be.js": 89,
	"./bg": 90,
	"./bg.js": 90,
	"./bm": 91,
	"./bm.js": 91,
	"./bn": 92,
	"./bn.js": 92,
	"./bo": 93,
	"./bo.js": 93,
	"./br": 94,
	"./br.js": 94,
	"./bs": 95,
	"./bs.js": 95,
	"./ca": 96,
	"./ca.js": 96,
	"./cs": 97,
	"./cs.js": 97,
	"./cv": 98,
	"./cv.js": 98,
	"./cy": 99,
	"./cy.js": 99,
	"./da": 100,
	"./da.js": 100,
	"./de": 101,
	"./de-at": 102,
	"./de-at.js": 102,
	"./de-ch": 103,
	"./de-ch.js": 103,
	"./de.js": 101,
	"./dv": 104,
	"./dv.js": 104,
	"./el": 105,
	"./el.js": 105,
	"./en-au": 106,
	"./en-au.js": 106,
	"./en-ca": 107,
	"./en-ca.js": 107,
	"./en-gb": 108,
	"./en-gb.js": 108,
	"./en-ie": 109,
	"./en-ie.js": 109,
	"./en-il": 110,
	"./en-il.js": 110,
	"./en-nz": 111,
	"./en-nz.js": 111,
	"./eo": 112,
	"./eo.js": 112,
	"./es": 113,
	"./es-do": 114,
	"./es-do.js": 114,
	"./es-us": 115,
	"./es-us.js": 115,
	"./es.js": 113,
	"./et": 116,
	"./et.js": 116,
	"./eu": 117,
	"./eu.js": 117,
	"./fa": 118,
	"./fa.js": 118,
	"./fi": 119,
	"./fi.js": 119,
	"./fo": 120,
	"./fo.js": 120,
	"./fr": 121,
	"./fr-ca": 122,
	"./fr-ca.js": 122,
	"./fr-ch": 123,
	"./fr-ch.js": 123,
	"./fr.js": 121,
	"./fy": 124,
	"./fy.js": 124,
	"./gd": 125,
	"./gd.js": 125,
	"./gl": 126,
	"./gl.js": 126,
	"./gom-latn": 127,
	"./gom-latn.js": 127,
	"./gu": 128,
	"./gu.js": 128,
	"./he": 129,
	"./he.js": 129,
	"./hi": 130,
	"./hi.js": 130,
	"./hr": 131,
	"./hr.js": 131,
	"./hu": 132,
	"./hu.js": 132,
	"./hy-am": 133,
	"./hy-am.js": 133,
	"./id": 134,
	"./id.js": 134,
	"./is": 135,
	"./is.js": 135,
	"./it": 136,
	"./it.js": 136,
	"./ja": 137,
	"./ja.js": 137,
	"./jv": 138,
	"./jv.js": 138,
	"./ka": 139,
	"./ka.js": 139,
	"./kk": 140,
	"./kk.js": 140,
	"./km": 141,
	"./km.js": 141,
	"./kn": 142,
	"./kn.js": 142,
	"./ko": 143,
	"./ko.js": 143,
	"./ky": 144,
	"./ky.js": 144,
	"./lb": 145,
	"./lb.js": 145,
	"./lo": 146,
	"./lo.js": 146,
	"./lt": 147,
	"./lt.js": 147,
	"./lv": 148,
	"./lv.js": 148,
	"./me": 149,
	"./me.js": 149,
	"./mi": 150,
	"./mi.js": 150,
	"./mk": 151,
	"./mk.js": 151,
	"./ml": 152,
	"./ml.js": 152,
	"./mn": 153,
	"./mn.js": 153,
	"./mr": 154,
	"./mr.js": 154,
	"./ms": 155,
	"./ms-my": 156,
	"./ms-my.js": 156,
	"./ms.js": 155,
	"./mt": 157,
	"./mt.js": 157,
	"./my": 158,
	"./my.js": 158,
	"./nb": 159,
	"./nb.js": 159,
	"./ne": 160,
	"./ne.js": 160,
	"./nl": 161,
	"./nl-be": 162,
	"./nl-be.js": 162,
	"./nl.js": 161,
	"./nn": 163,
	"./nn.js": 163,
	"./pa-in": 164,
	"./pa-in.js": 164,
	"./pl": 165,
	"./pl.js": 165,
	"./pt": 166,
	"./pt-br": 167,
	"./pt-br.js": 167,
	"./pt.js": 166,
	"./ro": 168,
	"./ro.js": 168,
	"./ru": 169,
	"./ru.js": 169,
	"./sd": 170,
	"./sd.js": 170,
	"./se": 171,
	"./se.js": 171,
	"./si": 172,
	"./si.js": 172,
	"./sk": 173,
	"./sk.js": 173,
	"./sl": 174,
	"./sl.js": 174,
	"./sq": 175,
	"./sq.js": 175,
	"./sr": 176,
	"./sr-cyrl": 177,
	"./sr-cyrl.js": 177,
	"./sr.js": 176,
	"./ss": 178,
	"./ss.js": 178,
	"./sv": 179,
	"./sv.js": 179,
	"./sw": 180,
	"./sw.js": 180,
	"./ta": 181,
	"./ta.js": 181,
	"./te": 182,
	"./te.js": 182,
	"./tet": 183,
	"./tet.js": 183,
	"./tg": 184,
	"./tg.js": 184,
	"./th": 185,
	"./th.js": 185,
	"./tl-ph": 186,
	"./tl-ph.js": 186,
	"./tlh": 187,
	"./tlh.js": 187,
	"./tr": 188,
	"./tr.js": 188,
	"./tzl": 189,
	"./tzl.js": 189,
	"./tzm": 190,
	"./tzm-latn": 191,
	"./tzm-latn.js": 191,
	"./tzm.js": 190,
	"./ug-cn": 192,
	"./ug-cn.js": 192,
	"./uk": 193,
	"./uk.js": 193,
	"./ur": 194,
	"./ur.js": 194,
	"./uz": 195,
	"./uz-latn": 196,
	"./uz-latn.js": 196,
	"./uz.js": 195,
	"./vi": 197,
	"./vi.js": 197,
	"./x-pseudo": 198,
	"./x-pseudo.js": 198,
	"./yo": 199,
	"./yo.js": 199,
	"./zh-cn": 200,
	"./zh-cn.js": 200,
	"./zh-hk": 201,
	"./zh-hk.js": 201,
	"./zh-tw": 202,
	"./zh-tw.js": 202
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 289;

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',[_c('v-snackbar',{attrs:{"timeout":_vm.snackbar.timeout,"top":_vm.snackbar.y === 'top',"bottom":_vm.snackbar.y === 'bottom',"right":_vm.snackbar.x === 'right',"color":_vm.snackbar.color,"text":"teal","left":_vm.snackbar.x === 'left',"multi-line":_vm.snackbar.mode === 'multi-line',"vertical":_vm.snackbar.mode === 'vertical'},model:{value:(_vm.snackbar.display),callback:function ($$v) {_vm.$set(_vm.snackbar, "display", $$v)},expression:"snackbar.display"}},[_vm._v("\n      "+_vm._s(_vm.snackbar.text)+"\n      "),(_vm.snackbar.showButton)?_c('v-btn',{attrs:{"flat":_vm.snackbar.flat,"color":_vm.snackbar.buttonColor},nativeOn:{"click":function($event){_vm.snackbar.display = false}}},[_vm._v("\n        "+_vm._s(_vm.snackbar.buttonText)+"\n      ")]):_vm._e()],1),_vm._v(" "),(_vm.isSessionMannagerPage())?_c('div',{attrs:{"id":"session-mannager-page"}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1)],1):_vm._e(),_vm._v(" "),(!_vm.isSessionMannagerPage())?_c('div',{attrs:{"id":"eeeeeeee"}},[_c('v-navigation-drawer',{attrs:{"mini-variant":_vm.miniVariant,"clipped":_vm.clipped,"fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-list',[_c('v-list-tile',[_c('v-list-tile-title',{staticClass:"title"},[_vm._v("\n                Instalaciones BEC\n              ")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',[_c('v-list-tile',{attrs:{"exact":"","router":"","to":{
              name: 'dashboard'
            }}},[_c('v-list-tile-title',{staticClass:"list-title",domProps:{"textContent":_vm._s('Home')}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"exact":"","router":"","to":{
              name: 'account',
              params: {
                username: 'me'
              }
            }}},[_c('v-list-tile-title',{staticClass:"list-title",domProps:{"textContent":_vm._s('Mi cuenta')}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"exact":"","router":"","to":{
              name: 'stats'
            }}},[_c('v-list-tile-title',{staticClass:"list-title",domProps:{"textContent":_vm._s('Estadísticas')}})],1),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-expansion-panel',_vm._l((_vm.parents),function(parent,i){return (!(parent.hidden || false))?_c('v-expansion-panel-content',{key:i},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{domProps:{"innerHTML":_vm._s(parent.icon)}}),_vm._v(" \n            "+_vm._s(parent.title)+"\n            ")],1),_vm._v(" "),_c('v-list',_vm._l((parent.childs),function(child,i){return (!(child.hidden || false))?_c('v-list-tile',{key:i,attrs:{"router":"","to":child.to,"exact":""}},[_c('v-list-tile-action',[_c('v-icon',{domProps:{"innerHTML":_vm._s(child.icon)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(child.title)}})],1)],1):_vm._e()}))],1):_vm._e()})),_vm._v(" "),_c('v-list',[_c('v-list-tile',{attrs:{"exact":"","router":""},on:{"click":function($event){_vm.logout()}}},[_c('v-list-tile-title',{staticClass:"list-title",domProps:{"textContent":_vm._s('Salir')}})],1)],1)],1),_vm._v(" "),(false)?_c('v-toolbar',{attrs:{"fixed":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}})],1):_vm._e(),_vm._v(" "),_c('v-toolbar',{attrs:{"fixed":"","app":"","clipped-left":_vm.clipped}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),(false)?_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.miniVariant = !_vm.miniVariant}}},[_c('v-icon',{domProps:{"innerHTML":_vm._s(_vm.miniVariant ? 'chevron_right' : 'chevron_left')}})],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","to":{
              name: 'dashboard'
            }},nativeOn:{"click":function($event){$event.stopPropagation();_vm.clipped = !_vm.clipped}},slot:"activator"},[_c('v-icon',[_vm._v("home")])],1),_vm._v(" "),_c('span',[_vm._v("Home")])],1),_vm._v(" "),(_vm.isSuperadmin() || _vm.isAdmin())?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","to":{
              name: 'equipments'
            }},nativeOn:{"click":function($event){$event.stopPropagation();_vm.clipped = !_vm.clipped}},slot:"activator"},[_c('v-icon',[_vm._v("settings_input_component")])],1),_vm._v(" "),_c('span',[_vm._v("Ver equipos")])],1):_vm._e(),_vm._v(" "),(_vm.isSuperadmin() || _vm.isAdmin())?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","to":{
              name: 'installers'
            }},nativeOn:{"click":function($event){$event.stopPropagation();_vm.clipped = !_vm.clipped}},slot:"activator"},[_c('v-icon',[_vm._v("build")])],1),_vm._v(" "),_c('span',[_vm._v("Ver instaladores")])],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","to":{
              name: 'bookings'
            }},nativeOn:{"click":function($event){$event.stopPropagation();_vm.clipped = !_vm.clipped}},slot:"activator"},[_c('v-icon',[_vm._v("alarm")])],1),_vm._v(" "),_c('span',[_vm._v("Ver reservas")])],1),_vm._v(" "),(_vm.isSuperadmin() || _vm.isAdmin() || _vm.isCommerce())?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","to":{
              name: 'bookingnew',
              params: {
                booking_id: 'new'
              }
            }},nativeOn:{"click":function($event){$event.stopPropagation();_vm.clipped = !_vm.clipped}},slot:"activator"},[_c('v-icon',[_vm._v("alarm_add")])],1),_vm._v(" "),_c('span',[_vm._v("Nueva reserva")])],1):_vm._e(),_vm._v(" "),(_vm.isSuperadmin() || _vm.isAdmin())?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","to":{
              name: 'bookings',
              query: { action: 'mark_as_finished' }
            }},nativeOn:{"click":function($event){$event.stopPropagation();_vm.clipped = !_vm.clipped}},slot:"activator"},[_c('v-icon',[_vm._v("alarm_on")])],1),_vm._v(" "),_c('span',[_vm._v("Marcar reservas como finalizadas")])],1):_vm._e(),_vm._v(" "),(false)?_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.fixed = !_vm.fixed}}},[_c('v-icon',[_vm._v("remove")])],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('img',{staticClass:"white-logo",attrs:{"src":"/static/images/login/logo-blanco.png","alt":""}}),_vm._v(" "),(false)?_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.rightDrawer = !_vm.rightDrawer}}},[_c('v-icon',[_vm._v("menu")])],1):_vm._e()],1),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1)],1)],1),_vm._v(" "),(false)?_c('v-navigation-drawer',{attrs:{"temporary":"","right":_vm.right,"fixed":""},model:{value:(_vm.rightDrawer),callback:function ($$v) {_vm.rightDrawer=$$v},expression:"rightDrawer"}},[_c('v-list',[_c('v-list-tile',{nativeOn:{"click":function($event){_vm.right = !_vm.right}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"light":""}},[_vm._v("compare_arrows")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Switch drawer (click me)")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-footer',{staticClass:"footer-app-inside",attrs:{"fixed":_vm.fixed,"height":"65px","app":""}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('span',[_vm._v("© Instalaciones BEC - 2019")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('router-link',{attrs:{"to":{ name: 'legal-advice' }}},[_vm._v("\n                Aviso legal\n              ")]),_vm._v(" "),_c('span',{staticClass:"router-separator"},[_vm._v(" | ")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'privacy-policy' }}},[_vm._v("\n                Privacidad\n              ")]),_vm._v(" "),_c('span',{staticClass:"router-separator"},[_vm._v(" | ")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'cookies-policy' }}},[_vm._v("\n                Cookies\n              ")])],1)],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony export (immutable) */ __webpack_exports__["a"] = createRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(292);




// The meta data for your routes
var meta = __webpack_require__(79);

// Function to create routes
// Is default lazy but can be changed
function route(name, path, view) {
  return {
    name: name,
    path: path,
    meta: meta[name],
    component: function component(resolve) {
      return __webpack_require__(293)("./" + view + '.vue').then(resolve);
    }
  };
}

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

function createRouter(store) {
  store.dispatch('api/prepareAuthorization');

  var mainAuthRoute = { name: 'dashboard' };

  var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    base: __dirname,
    mode: 'history',
    scrollBehavior: function scrollBehavior() {
      return { y: 0 };
    },
    routes: [
    // route('booking-new', '/admin/booking/create', 'booking-new'),
    route('booking-edit', '/admin/booking/:booking_id/edit', 'booking'), route('create-booking', '/bookings/new', 'create-booking'), route('dashboard', '/admin/dashboard', 'dashboard'), route('account', '/:username', 'account'), route('new-account', '/account/new/:type', 'account'),
    // route('equipment', '/admin/equipment', 'equipment'),
    route('equipment-id', '/admin/equipment/:equipment_id', 'equipment'), route('equipments', '/admin/equipments', 'equipments'), route('booking-new', '/admin/booking/:booking_id/:booking_start/:booking_end/', 'booking'), route('bookingnew', '/admin/booking/:booking_id/', 'booking'), route('booking-id', '/admin/booking/:booking_id/', 'booking'),
    // route('booking-added', '/admin/booking/:booking_id/:booking_added/', 'booking'),
    route('bookings', '/admin/bookings', 'bookings'), route('admins', '/account/admins', 'admins'), route('managers', '/account/managers', 'managers'), route('responsibles', '/account/responsibles', 'responsibles'), route('installers', '/account/installers', 'installers'), route('commerces', '/account/commerces', 'commerces'), route('inclusions', '/admin/installation/:type', 'taxonomies'), route('exclusions', '/admin/installation/:type', 'taxonomies'), route('observations', '/admin/installation/:type', 'taxonomies'), route('materials', '/admin/installation/:type', 'taxonomies'), route('types', '/admin/installation-types/', 'installation-types'), route('installation-type-id', '/admin/installation-type/:installation_type_id/', 'installation-type'), route('stats', '/admin/stats', 'stats'), route('login', '/account/login', 'session-mannager'), route('register', '/account/register', 'session-mannager'), route('change-password', '/account/change-password', 'session-mannager'), route('recover-password', '/account/recover-password', 'session-mannager'), route('privacy-policy', '/legal/privacy-policy', 'legal'), route('cookies-policy', '/legal/cookies-policy', 'legal'), route('legal-advice', '/legal/legal-advice', 'legal'),
    // Global redirect for 404
    { path: '*', redirect: mainAuthRoute }]
  });

  // Send a pageview to Google Analytics
  router.beforeEach(function (to, from, next) {
    if (typeof ga !== 'undefined') {
      /* eslint-disable */
      ga('set', 'page', to.path);
      ga('send', 'pageview');
    }
    var hasCredentials = store.getters['api/hasCredentials'];

    var requiresAuth = meta[to.name].requiresAuth || false;

    var isSessionPage = meta[to.name].isSessionPage || false;

    /**
     * FIX (get oly the status)
     */
    function getUserStatus() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        store.dispatch('api/authRequest', {
          method: 'get',
          url: 'user/profile/me/'
        }).then(function (response) {
          var index = response.data.findIndex(function (item) {
            return item.assign_to === 'status';
          });
          resolve(parseInt(response.data[index].value));
        }).catch(function (error) {
          console.log(error);
          reject(error);
        });
      });
    }

    if (localStorage.rolID > 3) {
      getUserStatus().then(function (statusID) {
        if (statusID !== 1) {
          return next({
            name: 'account',
            params: {
              username: 'me'
            }
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    }

    if (!hasCredentials) {
      if (!requiresAuth) {
        return next();
      }
      return next({ name: 'login' });
    } else {
      if (isSessionPage) {
        return next(mainAuthRoute);
      }
      var userRol = store.getters['api/getUserRol'];

      if (meta[to.name].permissions && meta[to.name].permissions.indexOf(userRol) === -1) {
        return next(mainAuthRoute);
      }
    }
    next();
  });

  return router;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./account.vue": [
		496,
		3
	],
	"./admins.vue": [
		497,
		19
	],
	"./booking (copia).vue": [
		498,
		2
	],
	"./booking-new.vue": [
		499,
		1
	],
	"./booking.vue": [
		500,
		0
	],
	"./bookings.vue": [
		501,
		18
	],
	"./calendar.vue": [
		502,
		20
	],
	"./change-password.vue": [
		503,
		7
	],
	"./commerces.vue": [
		504,
		17
	],
	"./dashboard.vue": [
		505,
		10
	],
	"./equipment.vue": [
		506,
		5
	],
	"./equipments.vue": [
		507,
		16
	],
	"./installation-type.vue": [
		508,
		4
	],
	"./installation-types.vue": [
		509,
		15
	],
	"./installers.vue": [
		510,
		14
	],
	"./legal.vue": [
		511,
		21
	],
	"./managers.vue": [
		512,
		13
	],
	"./register-store.vue": [
		513,
		8
	],
	"./register.vue": [
		514,
		22
	],
	"./responsibles.vue": [
		515,
		12
	],
	"./session-mannager.vue": [
		516,
		6
	],
	"./stats.vue": [
		517,
		9
	],
	"./taxonomies.vue": [
		518,
		11
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 293;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_snackbar__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_api__ = __webpack_require__(301);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

function createStore() {
  return new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
      snackbar: __WEBPACK_IMPORTED_MODULE_2_modules_snackbar__["a" /* default */],
      api: __WEBPACK_IMPORTED_MODULE_3_modules_api__["a" /* default */]
    },
    state: {},

    actions: {},

    mutations: {},

    getters: {}
  });
}

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config_snackbar__ = __webpack_require__(300);


var namespaced = true;

var state = {
  snackbar: __WEBPACK_IMPORTED_MODULE_0_config_snackbar__["a" /* default */]
};

var getters = {

  /**
   * Get snackbar configuration.
   *
   * @return {Object}
   */
  getDefaultConfig: function getDefaultConfig(state) {
    return state.snackbar;
  }
};

var actions = {

  /**
   * Show snackbar.
   *
   * @param {Object} context → vm
   * @param {Object} text    → snackbar text
   */
  show: function show(context, payload) {
    context.commit('show', payload);
  },

  /**
   * Hide snackbar.
   *
   * @param {Object} commit
   */
  hide: function hide(commit) {
    commit('hide');
  }
};

var mutations = {

  /**
   * Show snackbar.
   *
   * @param {Object} state → store payload
   */
  show: function show(state, payload) {
    state.snackbar.display = true;
    state.snackbar.text = payload.text || payload;
    state.snackbar.y = payload.y || state.snackbar.y;
    state.snackbar.x = payload.x || state.snackbar.x;
    state.snackbar.mode = payload.mode || state.snackbar.mode;
    state.snackbar.timeout = payload.timeout || state.snackbar.timeout;
    state.snackbar.text = payload.text || state.snackbar.text;
    state.snackbar.color = payload.color || state.snackbar.color;
    state.snackbar.buttonColor = payload.buttonColor || state.snackbar.buttonColor;
    state.snackbar.buttonText = payload.buttonText || state.snackbar.buttonText;
    state.snackbar.showButton = typeof payload.showButton !== 'undefined' ? payload.showButton : state.snackbar.showButton;
    state.snackbar.flat = typeof payload.flat !== 'undefined' ? payload.flat : state.snackbar.showButton;
  },

  /**
   * Hide snackbar.
   *
   * @param {Object} state → store payload
   */
  hide: function hide(state) {
    state.snackbar.display = false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: namespaced,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  display: false,
  y: 'bottom',
  x: null,
  mode: '',
  timeout: 3000,
  text: '',
  color: 'undefined',
  buttonColor: '#fff',
  buttonText: 'CERRAR',
  showButton: true,
  flat: true
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config_api__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_2_config_api__["a" /* default */].url;
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.post['Content-Type'] = 'multipart/form-data';

var namespaced = true;

var state = {
  code: 0,
  status: '',
  message: '',
  roles: __WEBPACK_IMPORTED_MODULE_2_config_api__["a" /* default */].roles,
  uuid: localStorage.uuid || 0,
  rolID: localStorage.rolID || 0,
  hasCredentials: false
};

var getters = {

  /**
   * Get api configuration.
   *
   * @return {Object}
   */
  hasCredentials: function hasCredentials(state) {
    return state.hasCredentials;
  },

  /**
   * Get api configuration.
   *
   * @return {Object}
   */
  getUserRol: function getUserRol(state) {
    return __WEBPACK_IMPORTED_MODULE_2_config_api__["a" /* default */].roles[state.rolID - 1] || 'guest';
  },

  /**
   * Get api configuration.
   *
   * @return {Object}
   */
  getUserId: function getUserId(state) {
    return state.uuid;
  },

  /**
   * Get api configuration.
   *
   * @return {Object}
   */
  getStatus: function getStatus(state) {
    return state.status;
  },

  /**
   * Get api configuration.
   *
   * @return {Object}
   */
  getMessage: function getMessage(state) {
    return state.message;
  }
};

var actions = {

  /**
   * Set api options.
   *
   * @param {Object} context → vm
   * @param {Object} state   → store payload
   * @param {Object} payload    → api params
   */
  request: function request(_ref, payload) {
    var dispatch = _ref.dispatch,
        commit = _ref.commit,
        state = _ref.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit('loading');
      var data = payload.data || [];
      if (payload.data && payload.method !== 'put') {
        data = new FormData();
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload.data).map(function (key) {
          data.set(key, payload.data[key]);
        });
      }
      return __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: payload.method,
        url: payload.url,
        data: data
      }).then(function (response) {
        commit('success');
        commit('code', response.status);
        commit('message', response.statusText);
        resolve(response);
      }).catch(function (error) {
        console.log(error.response);
        commit('error');
        commit('code', error.status);
        commit('message', error.response.data ? error.response.data.message : false || error.response.statusText);
        if (error.response.status === 401) {
          dispatch('logout');
          // location.reload()
        }
        reject(error);
      });
    });
  },


  /**
   * Set api options.
   *
   * @param {Object} context → vm
   * @param {Object} state   → store payload
   * @param {Object} payload → api params
   */
  authRequest: function authRequest(_ref2, payload) {
    var dispatch = _ref2.dispatch,
        commit = _ref2.commit,
        state = _ref2.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      payload.url = payload.url + __WEBPACK_IMPORTED_MODULE_2_config_api__["a" /* default */].sufix;
      dispatch('prepareAuthorization').then(function (response) {
        dispatch('request', payload).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },


  /**
   * Set api options.
   *
   * @param {Object} context → vm
   * @param {Object} state   → store payload
   * @param {Object} payload    → api params
   */
  prepareAuthorization: function prepareAuthorization(_ref3, payload) {
    var dispatch = _ref3.dispatch,
        commit = _ref3.commit,
        state = _ref3.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      dispatch('hasCredentials').then(function (response) {
        if (response) {
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = response.accessToken;

          // For new implementation
          // let nowTime = Date.now()
          // let expirationDate = new Date(response.expiresIn)
          // let expirationTime = expirationDate.getTime()
          // let remainingSeconds = expirationTime - nowTime

          var now = Date.now();
          var expiresIn = new Date(response.expiresIn || -1);
          var remainingSeconds = (expiresIn - now) / 1000;
          if (remainingSeconds < 60) {
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = response.refreshToken;
            dispatch('request', {
              method: 'post',
              url: __WEBPACK_IMPORTED_MODULE_2_config_api__["a" /* default */].token_renewal_route + __WEBPACK_IMPORTED_MODULE_2_config_api__["a" /* default */].sufix,
              data: { old_access_token: response.accessToken }
            }).then(function (response) {
              dispatch('setCredentials', response.data);
              resolve(response);
            }).catch(function (error) {
              dispatch('logout');
              reject(error);
            });
          }
          resolve(true);
        }
      });
    });
  },


  /**
   * Set api options.
   *
   * @param {Object} context → vm
   * @param {Object} state   → store payload
   * @param {Object} payload    → api params
   */
  hasCredentials: function hasCredentials(_ref4, payload) {
    var dispatch = _ref4.dispatch,
        commit = _ref4.commit,
        state = _ref4.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var expiresIn = localStorage.expiresIn || null;
      var accessToken = localStorage.accessToken || null;
      var refreshToken = localStorage.refreshToken || null;
      var uuid = localStorage.uuid || null;
      var rolID = localStorage.rolID || null;
      if (accessToken && refreshToken && expiresIn && uuid && rolID) {
        commit('hasCredentials');
        resolve({
          accessToken: accessToken,
          refreshToken: refreshToken,
          expiresIn: expiresIn,
          uuid: uuid,
          rolID: rolID
        });
      }
      resolve(false);
    });
  },


  /**
   * Set api options.
   *
   * @param {Object} context → vm
   * @param {Object} state   → store payload
   * @param {Object} payload    → api params
   */
  setCredentials: function setCredentials(_ref5, payload) {
    var dispatch = _ref5.dispatch,
        commit = _ref5.commit,
        state = _ref5.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var accessToken = payload.access_token || '';
      var refreshToken = payload.refresh_token || '';
      var expiresIn = payload.expires_in || '';
      var uuid = payload.uuid || '';
      var rolID = payload.rol_id || '';
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('expiresIn', expiresIn);
      localStorage.setItem('uuid', uuid);
      localStorage.setItem('rolID', rolID);
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = accessToken;
      if (accessToken && refreshToken && expiresIn && uuid && rolID) {
        commit('hasCredentials');
        resolve(true);
      } else {
        dispatch('logout');
        resolve(false);
      }
    });
  },


  /**
   * Set api options.
   *
   * @param {Object} context → vm
   * @param {Object} state   → store payload
   * @param {Object} payload    → api params
   */
  logout: function logout(_ref6, payload) {
    var dispatch = _ref6.dispatch,
        commit = _ref6.commit,
        state = _ref6.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      localStorage.clear();
      delete __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'];
      commit('logout');
      resolve(true);
    });
  }
};

var mutations = {

  /**
   * Set api options.
   *
   * @param {Object} state → store payload
   * @param {Object} payload  → api params
   */
  loading: function loading(state) {
    state.status = 'loading';
  },


  /**
   * Set api options.
   *
   * @param {Object} state → store payload
   * @param {Object} payload  → api params
   */
  success: function success(state) {
    state.status = 'success';
  },


  /**
   * Set api options.
   *
   * @param {Object} state → store payload
   * @param {Object} payload  → api params
   */
  error: function error(state) {
    state.status = 'error';
  },


  /**
   * Set api options.
   *
   * @param {Object} state → store payload
   * @param {Object} payload  → api params
   */
  message: function message(state, _message) {
    state.message = _message;
  },


  /**
   * Set api options.
   *
   * @param {Object} state → store payload
   * @param {Object} payload  → api params
   */
  code: function code(state, _code) {
    state.code = _code;
  },


  /**
   * Set api options.
   *
   * @param {Object} state → store payload
   * @param {Object} payload  → api params
   */
  hasCredentials: function hasCredentials(state, payload) {
    state.hasCredentials = true;
  },


  /**
   * Set api options.
   *
   * @param {Object} state → store payload
   * @param {Object} payload  → api params
   */
  logout: function logout(state) {
    state.hasCredentials = false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: namespaced,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 346:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 354:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 361:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 371:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 385:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 413:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 439:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 486:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 487:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 54:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors__);


/* harmony default export */ __webpack_exports__["a"] = ({
  default: {
    colors: {
      primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
      background: '#373c40',
      secondary: '#b0bec5',
      accent: '#8c9eff',
      error: '#b71c1c',
      card: '#1b2024'
    }
  },
  route: {
    'booking-edit': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'privacy-policy': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'legal-advice': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'cookies-policy': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'login': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.orange.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'inspire': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.orange.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'change-password': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.orange.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'recover-password': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.orange.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'register': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.orange.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'dark'
      }
    },
    'store': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.orange.base,
        secundary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.orange.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'light'
      }
    },
    'calendar': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'account': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'accounts': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'new-account': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'account-user-id': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'equipment': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'equipments': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'equipment-id': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'dashboard': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40',
        warning: '#ff9800'
      },
      styles: {
        card: 'light'
      }
    },
    'create-reservation': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40',
        success: '#0097a7',
        info: '#2196f3',
        error: '#ff5252',
        warning: '#ff9800'
      },
      styles: {
        card: 'light'
      }
    },
    'business-groups': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'companies': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'equipment-brands': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'brand-models': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'equipment-types': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'bookings': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'light'
      }
    },
    'admins': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'light'
      }
    },
    'commerces': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'light'
      }
    },
    'installers': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'light'
      }
    },
    'managers': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'light'
      }
    },
    'responsibles': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40',
        card: '#1b2024'
      },
      styles: {
        card: 'light'
      }
    },
    'booking-id': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'bookingnew': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'booking-added': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'booking-new': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'light'
      }
    },
    'indoor-unit-models': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'outdoor-unit-models': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'power-sources': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'types': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'installation-type-id': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'installation-costs': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'refrigerant-types': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'refrigerant-quantity': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'model-features': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'billing-types': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'payment-methods': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'material-designations': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'exclusions': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'stats': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    },
    'inclusions': {
      colors: {
        primary: __WEBPACK_IMPORTED_MODULE_0_vuetify_es5_util_colors___default.a.indigo.base,
        background: '#373c40'
      },
      styles: {
        card: 'dark'
      }
    }
  }
});

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mixins_meta__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mixins_theme__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_mixins_meta__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_mixins_theme__["a" /* default */]],

  data: function data() {
    return {
      fullscreenDialog: this.$store.getters['dialog/getFullscreenConfig'],
      snackbar: this.$store.getters['snackbar/getDefaultConfig'],
      clipped: false,
      drawer: false,
      fixed: false,
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      parents: [{
        title: 'Reservas',
        icon: '',
        childs: [
        /*
        {
          title: 'Nueva reserva',
          icon: '',
          hidden: this.isInstaller(),
          to: {
            name: 'booking-new',
            params: {
              booking_id: 'new',
              booking_start: moment().format('YYYY-MM-DD_HH:mm'),
              booking_end: moment().format('YYYY-MM-DD_HH:mm')
            }
          }
        },
        */
        {
          title: 'Nueva reserva',
          icon: '',
          hidden: this.isInstaller() || this.isManager() || this.isResponsible(),
          to: {
            name: 'booking-id',
            params: {
              booking_id: 'new'
            }
          }
        }, {
          title: 'Ver reservas',
          icon: '',
          to: {
            name: 'bookings'
          }
        }]
      }, {
        title: 'Equipos',
        hidden: this.isInstaller() || this.isCommerce() || this.isManager() || this.isResponsible(),
        icon: '',
        childs: [{
          title: 'Nuevo equipo',
          icon: '',
          to: {
            name: 'equipment-id',
            params: {
              equipment_id: 'new'
            }
          }
        }, {
          title: 'Ver equipos',
          icon: '',
          to: {
            name: 'equipments'
          }
        }]
      }, {
        title: 'Administradores',
        hidden: this.isInstaller() || this.isCommerce() || this.isAdmin() || this.isManager() || this.isResponsible(),
        icon: '',
        childs: [{
          title: 'Nuevo administrador',
          icon: '',
          to: {
            name: 'new-account',
            params: {
              type: 'admin'
            }
          }
        }, {
          title: 'Ver administradores',
          icon: '',
          to: {
            name: 'admins'
          }
        }]
      }, {
        title: 'Gerentes',
        hidden: this.isInstaller() || this.isCommerce() || this.isManager() || this.isResponsible(),
        icon: '',
        childs: [{
          title: 'Nuevo gerente',
          icon: '',
          to: {
            name: 'new-account',
            params: {
              type: 'manager'
            }
          }
        }, {
          title: 'Ver gerentes',
          icon: '',
          to: {
            name: 'managers'
          }
        }]
      }, {
        title: 'Encargados',
        hidden: this.isInstaller() || this.isCommerce() || this.isManager() || this.isResponsible(),
        icon: '',
        childs: [{
          title: 'Nuevo encargado',
          icon: '',
          to: {
            name: 'new-account',
            params: {
              type: 'responsible'
            }
          }
        }, {
          title: 'Ver encargados',
          icon: '',
          to: {
            name: 'responsibles'
          }
        }]
      }, {
        title: 'Comercios',
        hidden: this.isInstaller() || this.isCommerce(),
        icon: '',
        childs: [{
          title: 'Nuevo comercio',
          hidden: this.isManager() || this.isResponsible(),
          icon: '',
          to: {
            name: 'new-account',
            params: {
              type: 'commerce'
            }
          }
        }, {
          title: 'Ver comercios',
          icon: '',
          to: {
            name: 'commerces'
          }
        }]
      }, {
        title: 'Instaladores',
        hidden: this.isInstaller() || this.isCommerce() || this.isManager() || this.isResponsible(),
        icon: '',
        childs: [{
          title: 'Nuevo instalador',
          icon: '',
          to: {
            name: 'new-account',
            params: {
              type: 'installer'
            }
          }
        }, {
          title: 'Ver instaladores',
          icon: '',
          to: {
            name: 'installers'
          }
        }]
      }, {
        title: 'Instalaciones',
        hidden: this.isInstaller() || this.isCommerce() || this.isManager() || this.isResponsible(),
        icon: '',
        childs: [{
          title: 'Tipos de instalación',
          icon: '',
          to: {
            name: 'types',
            params: {
              type: 'types'
            }
          }
        }, {
          title: 'Inclusiones',
          icon: '',
          to: {
            name: 'inclusions',
            params: {
              type: 'inclusions'
            }
          }
        }, {
          title: 'Exclusiones',
          icon: '',
          to: {
            name: 'exclusions',
            params: {
              type: 'exclusions'
            }
          }
        }, {
          title: 'Observaciones',
          icon: '',
          to: {
            name: 'observations',
            params: {
              type: 'observations'
            }
          }
        }, {
          title: 'Materiales',
          icon: '',
          to: {
            name: 'materials',
            params: {
              type: 'materials'
            }
          }
        }]
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'IBEC'
    };
  },


  methods: {
    /**
     * Check if it is a login page.
     *
     * @return {Boolean}
     */
    isSessionMannagerPage: function isSessionMannagerPage() {
      return this.$route.name === 'login' || this.$route.name === 'register' || this.$route.name === 'change-password' || this.$route.name === 'recover-password';
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isSuperadmin: function isSuperadmin() {
      return this.$store.getters['api/getUserRol'] === 'superadmin';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isResponsible: function isResponsible() {
      return this.$store.getters['api/getUserRol'] === 'responsible';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isManager: function isManager() {
      return this.$store.getters['api/getUserRol'] === 'manager';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isAdmin: function isAdmin() {
      return this.$store.getters['api/getUserRol'] === 'administrator';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    logout: function logout() {
      this.$store.dispatch('api/logout');
      this.$router.push('/exit');
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isCommerce: function isCommerce() {
      return this.$store.getters['api/getUserRol'] === 'commerce';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isInstaller: function isInstaller() {
      return this.$store.getters['api/getUserRol'] === 'installer';
    },


    /**
     * Check if it is a login page.
     *
     * @return {Boolean}
     */
    isLegalPage: function isLegalPage() {
      return this.$route.name === 'privacy-policy';
    }
  }
});

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

module.exports = {"booking-edit":{"title":"Editar reserva - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor","commerce","installer"]},"login":{"title":"Login - Instalaciones BEC","description":"","keywords":"","isSessionPage":true},"register":{"title":"Registro - Instalaciones BEC","description":"","keywords":"","isSessionPage":true},"change-password":{"title":"Cambiar contraseña - Instalaciones BEC","description":"","keywords":"","isSessionPage":true},"recover-password":{"title":"Recuperar contraseña - Instalaciones BEC","description":"","keywords":"","isSessionPage":true},"privacy-policy":{"title":"Política de privacidad - Instalaciones BEC","description":"","keywords":""},"legal-advice":{"title":"Aviso legal - Instalaciones BEC","description":"","keywords":""},"cookies-policy":{"title":"Política de cookies - Instalaciones BEC","description":"","keywords":""},"dashboard":{"title":"Home - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor","commerce","installer","manager","responsible"]},"stats":{"title":"Estadísticas - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor","commerce","installer","manager","responsible"]},"account":{"title":"Cuenta - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor","commerce","installer","manager","responsible"]},"new-account":{"title":"Nueva cuenta - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor"]},"equipment-id":{"title":"Detalles del equipo - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor"]},"equipments":{"title":"Equipos - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor"]},"booking-new":{"title":"Reserva - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor","commerce","installer"]},"bookingnew":{"title":"Reserva - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor","commerce","installer"]},"booking-id":{"title":"Reserva - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor","commerce","installer","manager","responsible"]},"booking-added":{"title":"Detalles de la reserva - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor","commerce","installer"]},"bookings":{"title":"Reservas - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor","commerce","installer","manager","responsible"]},"installers":{"title":"Instaladores - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor"]},"commerces":{"title":"Comercios - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor","manager","responsible"]},"admins":{"title":"Administradores - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin"]},"managers":{"title":"Gerentes - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator"]},"responsibles":{"title":"Encargados - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator"]},"equipment":{"title":"","description":"Equipo - Instalaciones BEC","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor"]},"inclusions":{"title":"Inclusiones - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor"]},"exclusions":{"title":"Exclusiones - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor"]},"create-booking":{"title":"Crear reserva - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor","commerce"]},"observations":{"title":"Observaciones - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor"]},"materials":{"title":"Materiales - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor"]},"types":{"title":"Tipos de instalación - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor"]},"installation-type-id":{"title":"Tipo de instalación - Instalaciones BEC","description":"My Vuetify.js Project","keywords":"vue 2.0, vuetify","requiresAuth":true,"permissions":["superadmin","administrator","supervisor"]}}

/***/ })

},[252]);


// WEBPACK FOOTER //
// static/js/app.4d979ea8ec660cd752ac.js